<template>
  <footer>
    <div class="about">
      <div class="inner">
        <div class="navTitle">
        </div>
        <div class="about_us">
          <div class="top">
            <div class="leftBox">
              <div>
                <img :src="siteMess.logo" alt=""/>

              </div>
              <div class="navItem">
                <div class="item" v-for="(item,index) in navListall" :key="index" @click="navTo(item)">{{item.name}}</div>
              </div>
            </div>
            <div class="rightBox">
                <div class="title">联系我们</div>
                <div class="middle">
                  <div class="left">
                    <div class="li2">
                      <img class="imgicons" src="../../assets/images/dianhua.png" alt="" />
                      {{ company.companyPhone || "暂无联系电话" }}
                    </div>
                    <div class="li2">
                      <img class="imgicons" src="../../assets/images/youxiang.png" alt="" />
                      {{ company.companyEmail || "暂无电子邮箱" }}
                    </div>
                    <div class="li2">
                      <img class="imgicons" src="../../assets/images/dingwei.png" alt="" />
                      {{ company.companyAddress || "机构地址" }}
                    </div>
                  </div>
                  <div class="right" v-if="false">
                    <div class="code_box">
                      <div class="code_right">
                        <img
                          style="width: 110px;margin: 0px auto"
                          :src="company.companyAndroidPic"
                          alt="扫码下载Android端APP"
                        />
                        <div class="code_txt">扫码下载Android端APP</div>
                      </div>
                      <div class="code_right">
                        <img
                          style="width: 110px;margin: 0px auto"
                          :src="company.companyIOSPic"
                          alt="扫码下载iOS端APP"
                        />
                        <div class="code_txt">扫码下载iOS端APP</div>
                      </div>
                    </div>
                  </div>
                </div>
            </div>
          </div>
          <div class="bottom">
            <div class="inner">
              <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_band">
                <div>{{ company.companyName }}</div>
                <div class="left"> 技术支持：杰文信息</div>
                <div class="left">{{ company.companyBeian }}</div>
              </a>
              <!--  -->
            </div>
          </div>
        </div>
      </div>
    </div>


  </footer>
</template>
<script>
import { navList } from "@/api/navbar.js"
import {
  getWebsiteConfigInfo,
} from "@/api/home";
export default {
  props: {
    company: {
      type: Object,
      default: () => {
        return {
          IQ: {
            IOS: require("@/assets/images/erweima.png"),
            Android: require("@/assets/images/ios.png"),
          },
        };
      },
    },
  },
  created() {
    this.getnavlist();
    this.getWebsiteConfigInfo()
  },
  data() {
    return {
      siteMess:{},
      navListall:[],
      navitem: [
        { name: "首页", paths: "/home", id: "1010", oldvalpc: 1 },
        { name: "课程微课资源库", paths: "/course-center", id: "1030", oldvalpc: 2 },
        { name: "行业动态", paths: "/notice", id: "1020", oldvalpc: 3 },
        { name: "高级职业技能培训库", paths: "/library", id: "1040", oldvalpc: 4 },
        {
          name: "考核习题库",
          paths: "/mockExamination",
          id: "1090",
          oldvalpc: 5,
        },
      ],
    }
  },
  methods:{
    //获取网站基础信息
    getWebsiteConfigInfo(){
      getWebsiteConfigInfo().then(res => {
        localStorage.setItem('logo',res.data.icon)
        localStorage.setItem('name',res.data.siteName)
        this.siteMess=res.data
      });
    },
    // 导航栏列表
    getnavlist() {
      let params = {
        type: 0,
        status: 0,
      };
      navList(params).then((res) => {
        if (res.code == 200) {
          var dataArr = [];
          let datachild = [];
          res.tabMenuList.forEach((value, index) => {
            value["tabshow"] = false;
            value["oldvalpc"] = 99;
            value["tabchildren"] = [];
            value.id = value.id + "";
            switch (Number(value.id)) {
              case 54:
                //学业评价
                value["oldvalpc"] = 6;
                value["paths"] = "/aa";
                value.children.forEach((val, index) => {
                  val.id = val.id + "";
                  switch (Number(val.typeShow)) {
                    case 2:
                      //学业报告
                      val["paths"] =
                        "/stureport?navId=" +
                        value.id +
                        "&childtype=" +
                        val.id +
                        "&typeShow=" +
                        val.typeShow;
                      break;
                    case 3:
                      //职业测评
                      val["paths"] =
                        "/evaluating?navId=" +
                        value.id +
                        "&childtype=" +
                        val.id +
                        "&typeShow=" +
                        val.typeShow;
                      break;
                    case 4:
                      //预警帮扶
                      val["paths"] =
                        "/earlyWarning?navId=" +
                        value.id +
                        "&childtype=" +
                        val.id +
                        "&typeShow=" +
                        val.typeShow;
                      break;
                    default:
                      break;
                  }
                });
                dataArr.push(value);
                break;
              default:
                break;
            }
            if (value.oldvalpc == 99 || value.id == 5) {
              datachild.push(value);
            }
            //将children---type==0的子tab栏筛选出来
            value.tabchildren = value.children.filter((el) => {
              return el.type === "0";
            });
          });
          datachild.forEach((val, index) => {
            val.id = val.id + "";
            for (let index = 0; index < val.children.length; index++) {
              if (val.children.length > 0) {
                val.children[index].id = val.children[index].id + "";
              }
            }
            val["paths"] = "/navtab?navId=" + val.id;
          });
          // for (let index = 0; index < this.navitem.length; index++) {
          //   let tabval = this.navitem[index];
          //   if (tabval.id == 1050) {
          //     // tabval.submenuchildren = datachild;
          //   }
          // }
          this.navListall = [...this.navitem, ...dataArr, ...datachild];
          this.navListall.sort((a, b) => a.oldvalpc - b.oldvalpc);
        }
      });
    },
    navTo(item){
      this.$router.push({ path: item.paths });
    },

  }
};
</script>
<style lang="scss" scoped>
.about {
  background: #1D4434;
  color: #fff;

  .about_us {
    color: #FFFFFF;
    .top{
      display: flex;
      justify-content: flex-start;
      padding-top: 40px;
      padding-bottom: 21px;
      .leftBox{
        width: 256px;
        margin-right: 50px;
        .logo{
          width: 256px;
          height: 36px;
          background: url("../../assets/images/yema_logo.png");
          margin-bottom: 40px;
          background-size: 100% 100%;
        }
        .navItem{
          width: 256px;
          display: flex;
          justify-content: flex-start;
          flex-wrap: wrap;
          font-size: 14px;
          font-weight: 400;
          color: #FFFFFF;
          .item{
            cursor: pointer;
            width: 50%;
            margin-bottom: 24px;
          }

        }

      }
      .rightBox {
        flex-grow: 1;
        .title{
          font-size: 24px;
          font-weight: 500;
          padding-bottom: 20px;
          border-bottom: 1px solid #FFFAE9;
        }
        .middle{
          margin-top: 60px;
          display: flex;
          justify-content: space-between;
          .left{
            font-size: 14px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 35px;
            letter-spacing: 1px;
            .li2 {
              display: flex;
              margin-bottom: 30px;
              .imgicons {
                width: 15px;
                height: 15px;
                margin: 10px 5px 0 0;
                vertical-align: middle;
              }
            }
          }
          .right{
            font-size: 12px;
            font-weight: 400;
            color: #FFFFFF;
            line-height: 35px;
            .code_box {
              display: flex;
              text-align: center;
              .code_right {
                margin-right: 39px;
              }
              .code_txt {
                margin-top: 19px;
              }
            }
          }

        }
      }
    }
    .bottom {
      border-top: 1px solid #FFFAE9;
      padding: 30px 0px;
      font-size: 14px;
      font-weight: 400;
      color: #FFFAE9;
      .inner {
        a {
          display: flex;
          justify-content: center;
          color: #FFFAE9;
        }
        .left {
          margin-left: 10px;
        }
        div {
          cursor: pointer;
        }
      }
    }

  }
}
</style>
